export default __webpack_public_path__ + "static/viinitie-banner-wedding-desktop-wide.d66aaac309c524f31f7aa57523d292b0.webp";